<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-gmap #gmap [style]="{'width':'100%','height':'820px', 'margin-bottom': '1em'}" [options]="options" [overlays]="overlays"
       (onMapClick)="handleMapClick($event)" (onOverlayClick)="handleOverlayClick($event)" (onOverlayDragEnd)="handleDragEnd($event)"></p-gmap>

<!-- <button type="button" pButton label="Clear" icon="pi pi-times" (click)="clear()" style="margin-right:.25em"></button> -->
<!-- <button type="button" pButton label="Zoom In" icon="pi pi-plus" (click)="zoomIn(gmap.getMap())" style="margin-right:.25em"></button>
<button type="button" pButton label="Zoom Out" icon="pi pi-minus" (click)="zoomOut(gmap.getMap())"></button> -->

<p-dialog showEffect="fade" [(visible)]="dialogVisible" header="{{'MI_CHALLAN'| translate}}New Location" [style]="{width: '300px'}">>
    <div class="grid p-fluid" *ngIf="selectedPosition">
        <div class="col-2"><label for="title">{{'LABEL'| translate}}</label></div>
        <div class="col-10"><input type="text" pInputText id="title" [(ngModel)]="markerTitle"></div>

        <div class="col-2"><label for="lat">{{'LAT'| translate}}</label></div>
        <div class="col-10"><input id="lat" type="text" readonly pInputText [ngModel]="selectedPosition.lat()"></div>

        <div class="col-2"><label for="lng">{{'LNG'| translate}}</label></div>
        <div class="col-10"><input id="lng" type="text" readonly pInputText [ngModel]="selectedPosition.lng()"></div>

        <div class="col-2"><label for="drg">{{'DRAG'| translate}}</label></div>
        <div class="col-10"><p-checkbox [(ngModel)]="draggable" [binary]="True" [style]="{'margin-top':'.25em'}"></p-checkbox></div>
    </div>
    <ng-template pTemplate="footer">
        <div>
            <button type="button" pButton label="{{'ADD_MARKER'| translate}}" icon="pi-plus" (click)="addMarker()"></button>
        </div>
    </ng-template>
</p-dialog>